import styled from 'styled-components';
import { Flex } from 'UI';

export const SDiv = styled.div`
  width: 500px;
  margin: -12px;
  border: ${({ theme }) => `1px solid ${theme.color.grey85}`};
  border-radius: 8px;
`;

export const SHeaderFlex = styled(Flex)`
  padding: 12px 20px 12px 20px;
  border-radius: 8px 8px 0px 0px;
`;

export const SBodyFlex = styled(Flex)`
  padding: 10px 20px 20px 20px;
`;
